import newFetch from '@/utils/request'

// 获取新闻类型
export function newsType (params) {
  return newFetch({
    url: '/v1.Api/newsType',
    method: 'get',
    params
  })
}
// 获取新闻列表
export function getnews (params) {
  return newFetch({
    url: '/v1.Api/news',
    method: 'get',
    params
  })
}
// 获取新闻详情
export function newsDetail (params) {
  return newFetch({
    url: '/v1.Api/newsDetail',
    method: 'get',
    params
  })
}
//获取案例展示
export function caseShowcase (params) {
  return newFetch({
    url: '/v1.Api/caseShowcase',
    method: 'get',
    params
  })
}
// 获取案例展示详情
export function caseShowcaseDetail (params) {
  return newFetch({
    url: '/v1.Api/caseShowcaseDetail',
    method: 'get',
    params
  })
}
// 获取科技成果列表
export function evaluateAnswer (params) {
  return newFetch({
    url: '/v1.Api/evaluateAnswer',
    method: 'get',
    params
  })
}
// 获取科技成果详情
export function evaluateAnswerDetail (params) {
  return newFetch({
    url: '/v1.Api/evaluateAnswerDetail',
    method: 'get',
    params,
  })
}
// 获取评论科技下载列表
export function evaluationMaterials (params, data) {
  return newFetch({
    url: '/v1.Api/evaluationMaterials',
    method: 'post',
    params,
    data: data
  })
}
// 获取下载链接
export function evaluationMaterialsDownload (params) {
  return newFetch({
    url: '/v1.Api/evaluationMaterialsDownload',
    method: 'get',
    params
  })
}
// 获取科技查新
export function chaxinConfig (params) {
  return newFetch({
    url: '/v1.Api/chaxinConfig',
    method: 'get',
    params
  })
}
// 获取科技成果登记
export function achievementRegistrationConfig (params) {
  return newFetch({
    url: '/v1.Api/achievementRegistrationConfig',
    method: 'get',
    params
  })
}
// 获取科技奖励
export function technologyAwardsConfig (params) {
  return newFetch({
    url: '/v1.Api/technologyAwardsConfig',
    method: 'get',
    params
  })
}
// 关于我们
export function aboutUsConfig (params) {
  return newFetch({
    url: '/v1.Api/aboutUsConfig',
    method: 'get',
    params
  })
}
// 联系我们
export function contactInfoConfig (params) {
  return newFetch({
    url: '/v1.Api/contactInfoConfig',
    method: 'get',
    params
  })
}
// 提交咨询
export function submitConsult (params) {
  return newFetch({
    url: '/v1.Api/submitConsult',
    method: 'post',
    data: params
  })
}
// 获取合作单位列表
export function partner (params) {
  return newFetch({
    url: '/v1.Api/partner',
    method: 'get',
    params
  })
}
// 评价报告列表
export function evaluationReportList (params) {
  return newFetch({
    url: '/v1.Api/evaluationReportList',
    method: 'get',
    params
  })
}
// 评价报告详情
export function evaluationReportDetail (params) {
  return newFetch({
    url: '/v1.Api/evaluationReportDetail',
    method: 'get',
    params
  })
}
// 初始化
export function init (params) {
  return newFetch({
    url: '/v1.Api/init',
    method: 'get',
    params
  })
}
